import { Injectable } from '@angular/core';
import { GlobalCacheConfig } from 'ts-cacheable';
import { environment } from '@environments/environment';

/**
 * Ce service doit être appelé à l'initialisation de l'application
 * via les mécanismes angular APP_INITIALIZER.
 */
@Injectable()
export class AppInitializerService {
    constructor() {}

    public initialize(): Promise<void> {
        return new Promise<void>(resolve => {
            // configuration globale de ts-cache
            // pour le moment utilisé uniquement pour le cache des codifications
            // (nomenclatures, types, ...)
            //
            // Il sera peut être nécessaire de revisiter la configuration
            // si ce cache doit être utilisé pour d'autres choses
            //
            // Exemple: différentes régions de cache avec des configuration différentes
            GlobalCacheConfig.maxAge = environment.codification.cache.maxAge;
            GlobalCacheConfig.maxCacheCount = environment.codification.cache.maxCacheCount;
            resolve();
        });
    }
}
